// productId/productTreeId carry no length/format constraints beyond "is a valid UUID" (enforced
// by requiredUuidString in input.ts) -- these labels exist purely so link/unlink error messages
// stay consistent if either entity's user-facing name ever changes.
export const PRODUCT_TO_TREE_CONSTRAINTS = {
    productId: { label: 'Product' },
    productTreeId: { label: 'Category' },
};
//# sourceMappingURL=constraints.js.map